import { Locale } from '@headless-workspace/config';
import {
    PreviewOptions,
    Repository,
    Result,
    ResultEmpty,
    ResultFailureFromApiError,
    ResultSuccess,
} from '@headless-workspace/core-domain';
import {
    memoryCacheAuthStrategy,
    memoryCacheQueryParamStrategy,
    memoryCacheRefreshTokenStrategy,
} from '@headless-workspace/data';
import { PersistentBannerSlotDTO } from './PersistentBannerSlotDTO';
import { mapPersistentBannerSlot, PersistentBannerSlotValue } from './PersistentBannerSlotValue';

type FetchPersistentBannerSlotParams = PreviewOptions & {
    locale: Locale;
};

export interface PersistentBannerSlotRepositorySpec {
    fetchPersistentBannerSlot(params: FetchPersistentBannerSlotParams): Promise<Result<PersistentBannerSlotValue>>;
}

const SLOT_ID = 'persistent-banner-global';

export class PersistentBannerSlotRepository extends Repository implements PersistentBannerSlotRepositorySpec {
    path = '/content/v1';

    constructor() {
        super(memoryCacheAuthStrategy, memoryCacheRefreshTokenStrategy, memoryCacheQueryParamStrategy);
    }

    async fetchPersistentBannerSlot({
        locale,
        isPreviewable = false,
    }: FetchPersistentBannerSlotParams): Promise<Result<PersistentBannerSlotValue>> {
        try {
            const response = await this.datasource.getResource(`${this.path}/slots/${SLOT_ID}`, {
                locale,
                isPreviewable,
            });

            const persistentBannerSlotResponse = mapPersistentBannerSlot(PersistentBannerSlotDTO.parse(response));

            if (!persistentBannerSlotResponse) {
                return ResultEmpty();
            }

            return ResultSuccess(persistentBannerSlotResponse);
        } catch (error) {
            const apiError = this.handleApiError(error);
            return ResultFailureFromApiError(apiError, { locale });
        }
    }
}
